<script lang="ts" setup>
const props = defineProps<{ offerId: number }>();
const emits = defineEmits(['removed-from-cart']);

const cartStore = useCartStore();

const isLoading = ref(false);

async function removeFromCart() {
  if (isLoading.value) return;

  isLoading.value = true;

  await cartStore.removeFromCart([props.offerId]);
  emits('removed-from-cart');

  isLoading.value = false;
}
</script>

<template>
  <ConfirmationDropdown
    cancelBtnText="Нет"
    okBtnText="Да"
    text="Удалить из корзины?"
    @confirm="removeFromCart"
  >
    <button name="cart-item-remove-button">
      <SvgoSpinner
        v-if="isLoading"
        :font-controlled="false"
        class="size-5 animate-spin"
        filled
        title="Идет загрузка..."
      />

      <SvgoTrashBin
        v-else
        :font-controlled="false"
        class="trash-bin-icon-btn"
        filled
      />
    </button>
  </ConfirmationDropdown>
</template>

<style lang="scss" scoped>
.trash-bin-icon-btn {
  width: 24px;
  height: 24px;
  color: $hell-black-60;
  transition: all 0.2s;

  &:hover {
    color: $hell-red;
  }
}
</style>
